module.exports = __webpack_public_path__ + "img/vertical_6_4_4.b1b38f04.png";